var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-banner"},[_c('portal-target',{staticClass:"app-banner__header",attrs:{"name":"app-banner__header"}}),_c('portal-target',{staticClass:"app-banner__content",attrs:{"name":"app-banner__content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }